// extracted by mini-css-extract-plugin
export var boldText = "_7m-4";
export var checkboxContainer = "_7m-6";
export var closeIcon = "_7m-i";
export var container = "_7m-0";
export var drawer = "_7m-8";
export var drawerContent = "_7m-9";
export var extraSmallText = "_7m-5";
export var fulfillmentGroupTable = "_7m-e";
export var largeText = "_7m-3";
export var loadingSpinnerContainer = "_7m-j";
export var mediumText = "_7m-2";
export var narrow = "_7m-f";
export var notificationLink = "_7m-l";
export var packageCheckIconContainer = "_7m-7";
export var slideoutHeaderActions = "_7m-g";
export var slideoutHeaderActionsShifted = "_7m-h";
export var slideoutHeaderContainer = "_7m-a";
export var slideoutModal = "_7m-c";
export var stickyHeaderWrapper = "_7m-b";
export var table = "_7m-k";
export var tableContainer = "_7m-d";
export var tertiaryText = "_7m-1";